export type CompletedResultMethod =
  | 'AuctionSale'
  | 'SoldBeforeAuction'
  | 'SoldAfterAuction'
  | 'PrivateSaleTreaty'
  | 'PrivateSale'
  | 'SoldByTender'
  | 'SoldBySetDate'
  | 'Unknown'
  | 'Leased';

export const COMPLETED_RESULT_METHOD_TRANSLATION_KEY = 'completedResultMethod';
